import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { IReportState, reportTypes } from './types';
import * as reportActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: IReportState = {
  reports: [],
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: IReportState, action: UnsafeReturnType<T>): IReportState;
}

const getReports: IActionHandler<typeof reportActions['getReports']> = (state, { payload }) => ({
  ...state,
});

const getUserHealthReportById: IActionHandler<typeof reportActions['getUserHealthReportById']> = (state, { payload }) => ({
  ...state,
});

const getUserLocationReportById: IActionHandler<typeof reportActions['getUserLocationReportById']> = (state, { payload }) => ({
  ...state,
});

const getUserContactReportById: IActionHandler<typeof reportActions['getUserContactReportById']> = (state, { payload }) => ({
  ...state,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [reportTypes.GET_REPORTS]: getReports,
  [reportTypes.GET_USER_HEALTH_REPORT_BY_ID]: getUserHealthReportById,
  [reportTypes.GET_USER_LOCATION_REPORT_BY_ID]: getUserLocationReportById,
  [reportTypes.GET_USER_CONTACT_REPORT_BY_ID]: getUserContactReportById,
};

const reportReducer = createReducer<IReportState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { reportReducer, reportTypes, reportActions };
